<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- 地图组件 地图选点 -->
<template>
  <div class="map_container">
    <div :id="id" class="map_container" @contextmenu="removeInteraction">
      <a-button @click="addInteraction('Point')" style="position:absolute;right:10rem;z-index:5;top:1rem"
        v-if="type == 0">点</a-button>
      <a-button @click="addInteraction('LineString')" style="position:absolute;right:6rem;z-index:5;top:1rem"
        v-if="type == 1">线</a-button>
      <div v-if="type == 2">
        <input type="color" v-model="colorFormat" class="select-color">
        <a-button @click="addInteraction('Polygon')"
          style="position:absolute;right:2rem;z-index:5;top:1rem">面</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import storage from 'store'
import { LonLat } from '@/store/mutation-types'
import { getUUID } from '@/utils/util'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
// import { get as getProjection } from 'ol/proj'
import Draw from 'ol/interaction/Draw'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import { searchPlace, getLayerDetailByLayerCode, getByPipeLineLayerByZoneId } from '@/api/manage'
import * as olProj from 'ol/proj'
import GeoJSON from 'ol/format/GeoJSON'
import { watch } from 'less'
let map = null
let draw = null
var PointWatch = null

export default {
  name: 'CollectionMap',
  data () {
    return {
      colorFormat: 'rgb(255 255 255,0.2);',
      gcjMecators: null,
      map: null,
      id: getUUID(),
      tagInputValue: '',
      fillObj: new Fill({ color: 'rgb(0, 0, 0, 0.2)' }),
      // 天地图影像
      tdtHttpUrl: `http://t7.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=bbb8e87c166f332a270fa223ba022abb `,
      tdtHttpsUrl: `https://t7.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=bbb8e87c166f332a270fa223ba022abb `,
      //ArcGis地图
      arcgisUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      //高德地图
      gaodeUrl: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
      //谷歌地图影像 m 路线图、t 地形图、p 带标签的地形图、s 卫星图、y 带标签的卫星图、h 标签层（路名、地名等）
      xdtUrl1: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=y,m&gl=&x={x}&y={y}&z={z}',
      xdtUrl2: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s@815&gl=CN&hl=zh-CN&x={x}&y={y}&z={z}',

      tdUrl: 'http://t7.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2217db4d2cabf0ad3f9c0d8b29a85498'
    }
  },
  watch: {
    colorFormat (nval, oval) {
      const fcolor = this.olorRgb(nval, 0.2)
      this.fillObj = new Fill({ color: fcolor })
    }
  },
  props: {
    geo: {
      type: String,
      default: ''
    },
    mapType: {
      type: String,
      default: ''
    },
    type: {
      default: 0,
      type: Number
    },
    zoneId: {
      default: '',
      type: String
    },
    level: {
      default: '',
      type: String
    }
  },
  mounted () {
    this.initMap()
  },
  watch: {
    mapType: {
      handler (newValue, oldValue) {
        console.log(newValue)
        this.mapType = newValue
        const roadLayer = this.loadingMap(newValue, this.gcjMecators)
        map.addLayer(roadLayer)
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (PointWatch) {
      PointWatch()
    }
  },
  methods: {
    // 输入改变
    handleInputChange (e) {
      this.tagInputValue = e.target.value
    },
    // 初始化地图
    initMap () {
      console.log('初始化地图=====initMap')
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      // let projection = getProjection('EPSG:4326')
      this.gcjMecators = gcjMecator;
      let center = [106.456878, 29.541145]
      if (this.geo && this.geo !== '') {
        if (this.type === 0) {
          center = JSON.parse(this.geo).coordinates
        }
        if (this.type === 1) {
          center = JSON.parse(this.geo).coordinates[0]
        }
        if (this.type === 2) {
          center = JSON.parse(this.geo).coordinates[0][0]
        }
      } else {
        center = storage.get(LonLat);
      }

      map = new Map({
        view: new View({
          center: center, // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 12, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: this.id // 地图容器id
      })
      const roadLayer = this.loadingMap('高德地图', gcjMecator)

      map.addLayer(roadLayer)
      this.getLayers()
      PointWatch = this.$watch(
        'geo',
        function (nv, ov) {
          if (nv !== '{}' && nv !== '') {
            this.removeAllDraw()
            this.addGeojson({
              type: 'Feature',
              geometry: JSON.parse(nv)
            })
          }
        },
        { immediate: true }
      )
    },
    addGeojson (geojsonObject) {
      console.log(geojsonObject)
      const vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(geojsonObject)
      })
      const vectorLayer = new VectorLayer({
        source: vectorSource
      })
      map.addLayer(vectorLayer)
      const extent = vectorSource.getExtent()
      map.getView().fit(extent)
    },
    removeInteraction () {
      if (draw) {
        map.removeInteraction(draw)
      }
    },
    removeLastDraw () {
      if (draw) {
        draw.removeLastPoint()
      }
    },

    tileUrlFunction (coord, params1, params2) {
      return this.getVETileUrl(coord[0], coord[1], coord[2])
    },
    getVETileUrl (z, x, y) {
      for (var a = '', c = x, d = y, e = 0; e < z; e++) {
        a = ((c & 1) + 2 * (d & 1)).toString() + a
        c >>= 1
        d >>= 1
      }
      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + a + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    },
    loadingMap (value, gcjMecator) {
      console.log(111);

      let mapLayer
      if (value === '高德地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '高德地图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
          })
        })
        // map.setMaxZoom(25)
      } else if (value === '天地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '天地图底图',
          source: new XYZ({
            crossOrigin: 'anonymous',
            projection: 'EPSG:3857',
            url: 'http://t4.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=2217db4d2cabf0ad3f9c0d8b29a85498'
          })
        })
      } else if (value === '影像地图-天地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-天地图',
          source: new XYZ({
            crossOrigin: 'anonymous',
            projection: 'EPSG:3857',
            url: localStorage.getItem('env') === '生产' ? this.tdtHttpsUrl : this.tdtHttpsUrl
          })
        })
      } else if (value === '必应地图') {
        mapLayer = new TileLayer({
          name: '底图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            tileUrlFunction: this.tileUrlFunction
          })
        })
      } else if (value === '腾讯地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '高德地图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            url: 'http://rt0.map.gtimg.com/realtimerender?z={z}&x={x}&y={-y}&type=vector&style=0'
          })
        })
      } else if (value === '影像地图-ArcGis地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-ArcGis地图',
          source: new XYZ({
            projection: 'EPSG:3857', // 'EPSG:3857',
            crossOrigin: 'anonymous',
            url: this.arcgisUrl
          })
        })
      } else if (value === '影像地图-高德地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-高德地图',
          source: new XYZ({
            projection: gcjMecator, // 'EPSG:3857',
            crossOrigin: 'anonymous',
            url: this.gaodeUrl
          })
        })
      }

      return mapLayer
    },
    olorRgb (color, num) {
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      let sColor = color.toLowerCase()
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }// 处理六位的颜色值
        const sColorChange = []
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        return 'rgba(' + sColorChange.join(',') + ',' + num + ')'
      } else { return sColor }
    },
    // 开启、关闭交互
    addInteraction (type) {
      console.log(type);

      if (draw) {
        map.removeInteraction(draw)
      }
      map.getLayers().array_.forEach(item => {
        if (item.getSource().clear) {
          item.getSource().clear()
        }
      })

      let strokeColor = this.rgbaToHex(this.fillObj.color_);
      console.log(strokeColor);
      const source = new VectorSource()
      const vectorLayer = new VectorLayer({
        source: source,
        style: new Style({
          // 填充样式
          fill: this.fillObj,
          stroke: new Stroke({
            // 线样式
            color: strokeColor ? strokeColor : '#00c033',
            width: 2
          }),
          image: new Circle({
            // 点样式
            radius: 7,
            fill: new Fill({
              color: strokeColor ? strokeColor : '#00c033'
            })
          })
        })
      })
      map.addLayer(vectorLayer)

      draw = new Draw({
        source: source,
        fill: this.fillObj,
        type: type // 几何图形类型
        // geometryFunction: geometryFunction             //几何信息变更时的回调函数
      })
      console.log('addInteraction===', draw)
      map.addInteraction(draw)
    },
    rgbaToHex (rgba) {
      // 验证输入是否为rgba格式的字符串  
      const rgbaRegex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([\d\.]+)\s*\)$/;
      const match = rgba.match(rgbaRegex);
      if (!match) {
        throw new Error('Invalid RGBA format');
      }

      // 提取RGB值和透明度（虽然透明度在这个函数里不会被使用）  
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);

      // 将RGB值转换为十六进制  
      const toHex = (num) => {
        const hex = num.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      // 组合成十六进制颜色代码  
      const hexColor = `#${toHex(r)}${toHex(g)}${toHex(b)}`;

      return hexColor;
    },
    getLayers (level) {
      getLayerDetailByLayerCode('ALL_ZONE_PART_SHOW')
        .then(({ data }) => {
          console.log('ALL_ZONE_PART_SHOW', data)
          data.layerId = 'zone_metering_management_showfq'
          if (level) {

          } else {

          }
          let sql = level ? data.showFilterCondition + 'and level =' + level :
            data.showFilterCondition + 'and level =' + this.level
          this.wmsLayers(data, sql)
          this.loadingGisLayer('gw', 'gis_pipe_line')
          this.loadingGisLayer('llj', 'zone_associated_point', "and appendage = '分界阀门'")
          this.loadingGisLayer('fm', 'zone_associated_point', "and appendage = '考核流量计'")
        })
        .catch(e => {
          console.log(e)
        })
      if (this.zoneId) {
        getByPipeLineLayerByZoneId(this.zoneId)
          .then(({ data }) => {
            data.layerId = 'zone_metering_management_zoneId'
            this.wmsLayers(data, data.showFilterCondition)
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    // 清除全部
    removeAllDraw () {
      map.getLayers().array_.forEach(item => {
        item.getSource().clear && item.getSource().clear()
      })
    },
    deleteOne () {
      let length = map.getLayers().array_.length
      let allFeatures = map
        .getLayers()
        .array_[length - 1].getSource()
        .getFeatures()
      let featureLength = allFeatures.length
      if (featureLength === 0) {
        map.removeInteraction(draw)
        map.removeLayer(this.map.getLayers().array_[length - 1])
        length = map.getLayers().array_.length
        allFeatures = map
          .getLayers()
          .array_[length - 1].getSource()
          .getFeatures()
        featureLength = allFeatures.length
      }
      const newFeature = allFeatures[featureLength - 1]
      map
        .getLayers()
        .array_[length - 1].getSource()
        .removeFeature(newFeature)
    },
    // 地图打点
    addSimplePoint (x, y) {
      const point = new Point([x, y])
      const feature = new Feature(point)
      const vectorSource = new VectorSource()
      vectorSource.addFeature(feature)
      const vectorLayer = new VectorLayer({
        source: vectorSource,
        style: new Style({
          fill: new Fill({
            // 填充样式
            color: 'rgba(255, 255, 255, 0.2'
          }),
          stroke: new Stroke({
            // 线样式
            color: '#00c033',
            width: 2
          }),
          image: new Circle({
            // 点样式
            radius: 7,
            fill: new Fill({
              color: '#00c033'
            })
          })
        })
      })
      map.addLayer(vectorLayer)
    },
    // 找点位
    searchPoint () {
      console.log('找点位===searchPoint')
      searchPlace(this.tagInputValue).then(res => {
        if (res.pois.length > 0) {
          let findPointXY = res.pois[0].entr_location
          findPointXY = findPointXY.split(',')
          findPointXY[0] = Number(findPointXY[0])
          findPointXY[1] = Number(findPointXY[1])
        }
        this.addSimplePoint(findPointXY[0], findPointXY[1])
        map.getView().setCenter(findPointXY)
      })
    },
    showFQLayer (isShow) {
      this.removeGisGWLayer('zone_metering_management_showfq', isShow)
    },
    showGISLayer (str, isShow) {
      this.removeGisGWLayer(`gis_layer_${str}`, isShow)
    },
    loadingGisLayer (str, sou, sql = '') {
      // 显示GIS管网
      const obj = {
        id: `gis_layer_${str}`,
        workspace: 'smart_water',
        dataSource: `smart_water:${sou}`,
        showFilterCondition: `is_deleted = false and tenant_id = '${localStorage.getItem('tenant-user').split('_')[0]}' ${sql}`
      }
      this.wmsLayers(obj, obj.showFilterCondition)
    },
    removeGisGWLayer (lname, show) {
      console.log('移除指定分区名称===', map.getLayers().getArray())
      map.getLayers().getArray().forEach((layer) => {
        if (layer.get('name') === lname) {
          layer.setVisible(show)
        }
      })
    },
    getGeomeryData () {
      console.log('getGeomeryData===')
      const allLayer = map.getLayers().array_
      allLayer.forEach(item => {
        if (item.values_.title !== '高德地图' && item.values_.title !== '图层') {
          const Geom = item.getSource().getFeatures()
          Geom.forEach(items => {
            // 坐标点
            console.log(items.getGeometry().getCoordinates())
            // 数据类型（点、线、面、多面）
            console.log(items.getGeometry().getType())
            const geoString = JSON.stringify({
              type: items.getGeometry().getType(),
              coordinates: items.getGeometry().getCoordinates()
            })
            this.$emit('data', geoString)
          })
        }
      })
    },
    isLayerExist (id) {
      let is = false
      const allLayer = map.getLayers().getArray()
      allLayer.forEach(item => {
        if (item.values_.id === id) {
          console.log('图层已经处在了===', item)
          is = true
        }
      })
      return is
    },
    wmsFQLayers (layer, cql = '') {
      let clayer = {}
      map.getLayers().forEach(item => {
        console.log(item.values_.id)
        if (item.values_.id === layer.id) {
          clayer = item
        }
      })
      map.removeLayer(clayer)
      this.wmsLayers(layer, cql)
    },
    wmsLayers (layer, cql = '') {
      const params = { LAYERS: layer.dataSource, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        title: '图层',
        serverType: 'geoserver',
        url: `/api/geoserver/${layer.workspace}/wms`
      })
      const dtid = layer.layerId || layer.id
      const wmsLayer = new ImageLayer({
        id: dtid,
        name: dtid,
        title: '图层',
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 9999
      })
      map.addLayer(wmsLayer)
    }
  }
}
</script>
<style lang="less" scoped>
.map_container {
  width: 100%;
  height: 100%;
  position: relative;

  .select-color {
    position: absolute;
    right: 5rem;
    z-index: 5;
    top: 1rem;
    height: 35px;
  }
}
</style>
